<template>
    <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="openModal">
        <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"></div>

        <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
                <div class="relative w-full max-w-lg overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl">
                    <div class="px-3 pt-4 pb-3 bg-white sm:p-6 sm:pb-3">
                        <slot name="modal-body"></slot>
                    </div>
                    
                    <div class="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6">
                        <slot name="action-button"></slot>
                        <button @click="closeModal" type="button" class="inline-flex justify-center w-full px-4 py-1 mt-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script setup>
import { reactive, watch} from 'vue'

let props = defineProps({
    openModal: {
        type: Boolean,
        required: true
    }
})
const emit = defineEmits(['changeModal'])
let state = reactive({ 
   removeModal:props.openModal
})

function closeModal(){
    emit('changeModal',  props.openModal)
}
</script>
